import { AccessTypes, siteScreenNavigation } from "./constants";
import roles from "./roles";

/**
 * Centralized site navigation builder
 * This eliminates the need for every component to manually build navigation arrays
 */
export const buildSiteNavigation = (userRole, isSiteUser, customCaptions, position) => {
	let navigation = [...siteScreenNavigation];

	// Super admin filtering
	if (userRole === roles.superAdmin) {
		navigation = navigation.filter((item) => item.name !== "Assets");
	}

	// Site user filtering and customization
	if (userRole === roles.siteUser || isSiteUser) {
		const hasAssetAccess = position?.assetAccess !== AccessTypes.None;

		if (hasAssetAccess) {
			navigation = [
				{ name: "Details", url: siteScreenNavigation[0].url },
				{
					name: customCaptions?.assetPlural || "Assets",
					url: siteScreenNavigation[1].url,
				},
				{
					name: customCaptions?.departmentPlural || "Departments",
					url: siteScreenNavigation[2].url,
				},
			];
		} else {
			navigation = [
				{ name: "Details", url: siteScreenNavigation[0].url },
				{
					name: customCaptions?.departmentPlural || "Departments",
					url: siteScreenNavigation[2].url,
				},
			];
		}
	}

	return navigation;
};

/**
 * Hook to get site navigation for current user
 */
export const useSiteNavigation = (userInfo) => {
	const { role, isSiteUser, customCaptions, position } = userInfo;
	return buildSiteNavigation(role, isSiteUser, customCaptions, position);
};

/**
 * Get site navigation with user data from localStorage
 */
export const getSiteNavigationFromStorage = (getLocalStorageData) => {
	const userInfo = getLocalStorageData("me");
	return buildSiteNavigation(
		userInfo.role,
		userInfo.isSiteUser,
		userInfo.customCaptions,
		userInfo.position
	);
};